import React from "react";
import { Link } from "react-router-dom";
import { colors, fonts } from "../theme";
import { categories } from "../data";
import { Eyebrow, Btn, PhoneLink } from "../ui";
import Seo from "../../seo/Seo";
import { PAGE_META } from "../../seo/pageMeta";

const wrap = { maxWidth: "1180px", margin: "0 auto" };

/**
 * Real 404 page. Prerendered to build/404.html and served by Apache's
 * ErrorDocument with a genuine 404 status, so dead URLs drop out of the index
 * instead of lingering as soft 404s. The category links give both crawlers and
 * lost visitors a route back into the site.
 */
export default function NotFound() {
  return (
    <main
      className="se-page"
      style={{
        ...wrap,
        padding: "clamp(44px,10vw,80px) var(--sp-gutter) clamp(56px,12vw,100px)",
      }}
    >
      <Seo
        title={PAGE_META.notFound.title}
        description={PAGE_META.notFound.description}
        path="/404"
        noindex
      />

      <Eyebrow>Error 404</Eyebrow>
      <h1
        style={{
          fontFamily: fonts.serif,
          fontSize: "var(--fs-h1)",
          fontWeight: 500,
          margin: "12px 0 10px",
          maxWidth: "20ch",
        }}
      >
        We couldn't find that page
      </h1>
      <p style={{ fontSize: "16.5px", color: colors.muted, maxWidth: "56ch", margin: "0 0 32px" }}>
        The link may be out of date or mistyped. Everything we stock is in the
        catalogue below — or WhatsApp us on{" "}
        {/* Sat inline as a 20px target, and the number could break across
            lines mid-digit-group. inline-block + nowrap keeps it whole; the
            negative margin cancels the padding so the surrounding sentence
            does not reflow. */}
        <PhoneLink
          style={{
            color: colors.brown,
            whiteSpace: "nowrap",
            display: "inline-block",
            padding: "12px 4px",
            margin: "-12px -4px",
          }}
        />{" "}
        and we'll point you to the right grade.
      </p>

      <div style={{ display: "flex", gap: "14px", flexWrap: "wrap", marginBottom: "52px" }}>
        <Btn variant="dark" to="/catalogue">
          View catalogue →
        </Btn>
        <Btn variant="ghost" to="/contact">
          Contact us
        </Btn>
      </div>

      <div
        style={{
          borderTop: `1px solid ${colors.border}`,
          paddingTop: "28px",
          display: "grid",
          // min(240px,100%) keeps the track floor inside the column instead of
          // holding 240px in a 280px phone column and scrolling sideways.
          gridTemplateColumns: "repeat(auto-fit,minmax(min(240px,100%),1fr))",
          gap: "14px",
        }}
      >
        {/* These six links are the entire recovery path off a dead URL and
            were 20px-tall text runs. Each gets a 48px box, and a hairline so
            the one-column stack on a phone reads as separate rows rather than
            one block of text. */}
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/catalogue/${cat.slug}`}
            style={{
              display: "flex",
              alignItems: "center",
              minHeight: "48px",
              fontSize: "var(--fs-body)",
              color: colors.ink3,
              cursor: "pointer",
              borderBottom: `1px solid ${colors.borderSoft}`,
            }}
          >
            {cat.name} →
          </Link>
        ))}
      </div>
    </main>
  );
}
